import React, { useEffect } from 'react';
import proptypes from 'prop-types';
const { string, bool } = proptypes;

import { params, shape, string as stringType } from '@thd-nucleus/data-sources';
import { ImpressionProvider } from '@thd-olt-component-react/impression';
import { StoreWorkshopsComponent } from './StoreWorkshopComponent';

const StoreWorkshops = ({ entryID, isCard, enableB2CRadius }) => {
  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('store-workshops.ready');
  }, []);

  return (
    <ImpressionProvider
      data={{
        id: entryID,
        component: 'StoreWorkshops',
        name: 'StoreWorkshops',
        type: 'content',
        position: 1,
      }}
    >
      <StoreWorkshopsComponent entryID={entryID} isCard={isCard} enableB2CRadius={enableB2CRadius} />
    </ImpressionProvider>
  );
};

StoreWorkshops.displayName = 'StoreWorkshops';

StoreWorkshops.dataModel = {
  product: params({ itemId: stringType().isRequired() }).shape({
    itemId: stringType(),
    dataSource: stringType(),
    identifiers: shape({
      productLabel: stringType(),
    }),
  }),
};

export { StoreWorkshops };

StoreWorkshops.propTypes = {
  entryID: string,
  isCard: bool,
  enableB2CRadius: bool,
};

StoreWorkshops.defaultProps = {
  entryID: '',
  isCard: undefined,
  enableB2CRadius: false,
};
